import { createMapOfSet } from '../../shared';

/**
 * Determines the persona to display after deleting one or more personas.
 * @param displayedPersonaIds All personas in the list
 * @param personaIdsBeingDeleted Personas being deleted
 */
export function getClickedPersonaAfterDeleteOrMove(
    displayedPersonaIds: string[],
    personaIdsBeingDeleted: string[]
): string {
    if (!displayedPersonaIds || !personaIdsBeingDeleted) {
        return undefined;
    }

    if (personaIdsBeingDeleted.length === 1) {
        // A single persona is being deleted. In these cases we prefer to display the next persona in the list
        const deletedPersonaIndex = displayedPersonaIds.indexOf(personaIdsBeingDeleted[0]);
        if (displayedPersonaIds.length === 1) {
            // Deleting when the list just contains a single persona
            return undefined;
        } else if (deletedPersonaIndex === displayedPersonaIds.length - 1) {
            // Deleting the last persona in the list
            return displayedPersonaIds[deletedPersonaIndex - 1];
        } else {
            // Normal case. We display the persona after the deleted one.
            return displayedPersonaIds[deletedPersonaIndex + 1];
        }
    } else {
        // Multiple personas are being deleted. Find the index of the last clicked persona
        const lastClickIndex = displayedPersonaIds.indexOf(
            personaIdsBeingDeleted[personaIdsBeingDeleted.length - 1]
        );

        // Find the first displayed entry that is below the last clicked persona and not deleted
        // E.g. A [B] [C] D [E] F will focus D if B/C were clicked last, or F if E was clicked last.
        const beingDeletedMap = createMapOfSet(personaIdsBeingDeleted);
        return displayedPersonaIds.slice(lastClickIndex).find(persona => !beingDeletedMap[persona]);
    }
}

/**
 * Determines the persona to display after removing a favorite
 * @param displayedPersonaIds All personas in the list
 * @param favoriteId the persona who was unfavorited
 */
export function getClickedPersonaAfterFavoriteRemoved(
    displayedPersonaIds: string[],
    favoriteId: string
): string {
    if (!displayedPersonaIds || !favoriteId) {
        return undefined;
    }

    const removedPersonaIndex = displayedPersonaIds.indexOf(favoriteId);
    if (displayedPersonaIds.length === 1) {
        // Deleting when the list just contains a single persona
        return undefined;
    } else if (removedPersonaIndex === displayedPersonaIds.length - 1) {
        // Deleting the last persona in the list
        return displayedPersonaIds[removedPersonaIndex - 1];
    } else {
        // Normal case. We display the persona after the deleted one.
        return displayedPersonaIds[removedPersonaIndex + 1];
    }
}
